import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { ApiUrls, Doctypes } from 'src/app/shared/api-urls';
import { forkJoin, merge } from 'rxjs';
import { DateToFilter } from 'src/app/shared/date-filter';
import { FiScannerService } from 'src/app/shared/services/fi-scanner.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { FileuploadProgressbarService } from 'src/app/resuable/fileupload-progressbar/fileupload-progressbar.service';

import moment from 'moment';
import { eventNames } from 'process';

class posChecksFilter {
  itemsPerPage = 20;
  currentPage = 1;
  totalCount = 0;
  start = 0

  config: any;
  search = '';
  checkDate = '';
  filterBy = 'Today';
  filterType = 'creation'
  active = "1"
  underprocessing = ''
  selectCreationDate = ''

}
@Component({
  selector: 'app-pos-uploads',
  templateUrl: './pos-uploads.component.html',
  styleUrls: ['./pos-uploads.component.scss']
})
export class PosUploadsComponent implements OnInit {
  underprocessing: boolean = false;
  filters = new posChecksFilter();
  onSearch = new EventEmitter();
  private destroyEvents: EventEmitter<boolean> = new EventEmitter();

  companyDetails: any = {};
  creation = ''
  activeTab: number = 0;
  relink: boolean = false;
  posuploaddata: any = [];
  // posChecksDate=moment(new Date()).format('MMM');
  posChecksDate;
  selectedItem: any = {}
  date_type = ''
  message;
  selectedFiles = [];
  allFilesUplaoded;
  progressInfos = [];
  // underprocessing
  containerId = "dwtcontrolContainer";
  apiDomain = environment.apiDomain;
  // today = moment(new Date()).format("YYYY-MM-DD")
  sortedData = [];
  today: Date = new Date();
  minDate: Date = this.calculateMinDate();
  // formattedPosChecksDate: string;
  constructor(private activatedRoute: ActivatedRoute, private socketService: SocketService, private toaster: ToastrService,
    private scannerService: FiScannerService, private http: HttpClient, public modal: NgbModal, private router: Router, public fileuploadProgressbarService: FileuploadProgressbarService,) { }

  ngOnInit(): void {
    // this.setDefaultMonthYear()
    this.sortData();
    this.companyDetails = JSON.parse(localStorage.getItem('company'))

    if (this.companyDetails) {
      this.filters.itemsPerPage = this.companyDetails.items_per_page;

    }
    this.getPOSChecksData();
    // this.getinvoicesList()
    // this.pdfInvoice(this.invoicePdf,name)
    this.onSearch.pipe(debounceTime(500)).subscribe((res) => {
      console.log("pipe search")
      this.filters.start = 0;
      this.filters.totalCount = 0;
      this.updateRouterParams()


    });
    this.scannerService.scannedFileUploadedRes.pipe(takeUntil(this.destroyEvents)).subscribe((res: any) => {
      if (!res) { return; }
      if (res.message) {
        this.getPOSChecksData()
      }
    })

    merge(this.socketService.newPosChecks.pipe(takeUntil(this.destroyEvents)))
      .pipe(debounceTime(300)).subscribe((data) => this.getPOSChecksData());
    this.activatedRoute.queryParams.subscribe((res: any) => {
      if (res) {
        this.filters.checkDate = res.checkDate;
      }
    })


    this.socketService.newPosUploads.pipe(takeUntil(this.destroyEvents)).subscribe((res: any) => {
      this.getPOSChecksData()
     this.updateRouterParams()
      console.log('upload refreshed')

    })
  }
  sortData() {
    const statusOrder = {
      'Error': 1,
      'Pending': 2,
      'Processing': 3,
      'Completed': 4
    };

    this.sortedData = this.posuploaddata.slice().sort((a, b) => {
      return statusOrder[a.status] - statusOrder[b.status];
    });
  }

  getPOSChecksData(): void {
    const queryParams: any = { filters: [] };
    if (this.filters.selectCreationDate) {
      queryParams.filters.push(['creation', 'like', `%${this.filters.selectCreationDate}%`])

    }

    if (this.underprocessing == true) {
      if (this.filters.underprocessing) {
        queryParams.filters.push(['status', 'like', `%${this.filters.underprocessing}%`])

      }
    } else {
      queryParams.filters.push(['status', 'in', ['Completed', 'Processing', 'Pending', 'Error']])


    }

    queryParams.limit_start = this.filters.start
    queryParams.limit_page_length = 'none';
    queryParams.fields = JSON.stringify(["*"]);
    queryParams.filters = JSON.stringify(queryParams.filters);

    this.http.get(`${ApiUrls.posChecksHistory}`, { params: queryParams }).subscribe((res: any) => {

      this.posuploaddata = res.data

      let statusOrder = {
        'Error': 1,
        'Processing': 2,
        'Pending': 3,
        'Completed': 4
      };

      this.posuploaddata = this.posuploaddata.slice().sort((a: any, b: any) => {
        return statusOrder[a.status] - statusOrder[b.status];
      });
      this.activeTab = this.posuploaddata[0]?.name
      if (this.posuploaddata?.length) {
        this.getdatauploads(this.posuploaddata[0])
      }

    });
  }
  updateRouterParams(): void {
    this.router.navigate(['home/pos-uploads'], {
      queryParams: this.filters
    });
  }
  ngOnDestroy() {
    this.modal.dismissAll();
    this.destroyEvents.next();
    this.destroyEvents.unsubscribe();
  }


  getdatauploads(item) {
    this.selectedItem = item
    this.activeTab = item?.name
  }
  selectCheckDate_new(dt1: any) {
    this.creation = moment(dt1.value).format("YYYY-MM-DD")
    this.filters.selectCreationDate = this.creation;
    this.getPOSChecksData()
  }
  clearDate() {
    this.filters.selectCreationDate = '';
    this.creation = ''
    this.getPOSChecksData()

  }

  checked_pending() {
    console.log(this.filters.underprocessing)
    if (this.underprocessing == true) {
      this.filters.underprocessing = 'Pending'

    }
    this.updateRouterParams()
    this.getPOSChecksData()

  }
  calculateMinDate(): any {
    const minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    minDate.setDate(minDate.getDate() - 7);
    return minDate;


  }
  scanPosChecks(selectDateToScan, type) {
    this.posChecksDate = ''; this.date_type = type;
    // this.onMonthYearChange(event,'dt2')
    if (type == 'scan') {
      this.scannerService.dynamSoftOnload(false, this.containerId)
    }
    let modal = this.modal.open(selectDateToScan, { size: 'md', centered: true })
    // this.setDefaultMonthYear()
  
  }
  uploadPosChecksFn(uploadPOSChecks) {
    this.message = ''; this.selectedFiles = []; this.progressInfos = []; this.allFilesUplaoded = false
    let modal = this.modal.open(uploadPOSChecks, { size: 'lg', centered: true })
    modal.result.then((res: any) => {
      if (res == 'success') {
        this.getPOSChecksData();
      }
    })
  }
  async uploadFiles() {
    let data = {
      files: this.selectedFiles,
      is_private: 1,
      folder: 'Home',
      attached_to_doctype: Doctypes.posChecks,
      date: this.posChecksDate,
      attached_to_name: 'POS Checks'
    }
    this.fileuploadProgressbarService.isFilesUploading.emit(true)
    setTimeout(() => {
      this.fileuploadProgressbarService.uploadedFiles.emit(data)

    }, 500);
    this.message = '';
    this.modal.dismissAll()

  }
  reprocessCheck() {
    this.http.get(ApiUrls.reProcessChecks).subscribe((res: any) => {
      console.log(res)
      if(res?.message?.success){
           this.toaster.success(res?.message?.message)
      }
      // if (Array.isArray(res)) {
      //   res.forEach(item => {
      //     if (item && item.message) {
      //       this.toaster.success(item.message, 'Success');
      //     } else if (item && item.success) {
      //       this.toaster.success('Operation was successful', 'Success');
      //     }
      //   });
      // }
    }
    );


  }


  selectFiles(files) {
    Array.from(files).forEach(file => {
      this.selectedFiles.push({ progress: 0, file });
    });
  }
  previewcheck(viewcheck,item){
    this.selectedItem = item
    let modal = this.modal.open(viewcheck, { size: 'md', windowClass: 'sideMenuPdfcheckview', })
  }
  checkPagination(): void {
    this.filters.currentPage = 1;
    this.updateRouterParams();
  }
  // onMonthYearChange(event: any, dt2: any) {
  //   const selectedMonthYear = event.target.value;
  //   const [year, month] = selectedMonthYear.split('-');
  //   const firstDayOfMonth = moment(selectedMonthYear).startOf('month').toDate();
  //   const lastDayOfMonth = moment(selectedMonthYear).endOf('month').toDate();
  //   // this.minDate = firstDayOfMonth;
  //   // this.maxDate = lastDayOfMonth;
  //   this.posChecksDate = selectedMonthYear;
  //   console.log(this.posChecksDate, 'lllllllllll');
  //   dt2.close();
  // }
  // setDefaultMonthYear() {
  //   const currentMonthYear = moment().format('YYYY-MM');
  //   this.posChecksDate = currentMonthYear;
  //   this.updateFormattedDate();
  // }
  // updateFormattedDate() {
  //   this.formattedPosChecksDate = moment(this.posChecksDate).format('MM/YYYY'); // or 'MM-YYYY' for hyphen
  // }
}
